<span id="headline1" class="plusHeadline addSection" >
  <i class="icon-add-headline" (click)="addNewSection()"></i>
</span>
<ng-container *ngFor="let addedSection of listOfSecondarySections;let i = index">
  <app-secondary-section-form [sendAddedSection]="addedSection" [storyEditMode]=[storyEditMode]
   [sectionSuggestionList1]="secondarySectionSuggestion" [subsectionSuggestionList]="subsectionSuggestion" [listOfAllSubsections]="allSubSections"
    [index]="i" (sectionChanged)="sectionChangedHandler($event)">
  </app-secondary-section-form>
    <span class="deleteHeadline" id="headline2">
      <i class="icon-delete"  (click)="deleteSection(addedSection)"></i>
    </span>
</ng-container>
